// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  // newPassword: path(ROOTS_AUTH, '/new-password'),
  newPassword: (token) => path(ROOTS_DASHBOARD, `/new-password/${token}`),
};

export const PATH_PAGE = {
  // comingSoon: '/coming-soon',
  // maintenance: '/maintenance',
  // pricing: '/pricing',
  // payment: '/payment',
  // about: '/about-us',
  // contact: '/contact-us',
  // faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  // components: '/components',
  orgSelect: '/org-select',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  gps: path(ROOTS_DASHBOARD, '/cvo-locator'),
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
  blank: path(ROOTS_DASHBOARD, '/blank'),
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    animals: path(ROOTS_DASHBOARD, '/animals-involved'),
    aiSettings: path(ROOTS_DASHBOARD, '/ai-settings'),
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    new: path(ROOTS_DASHBOARD, '/user/new'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    edit: (name) => path(ROOTS_DASHBOARD, `/user/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
  },
  task: {
    root: path(ROOTS_DASHBOARD, '/task'),
    new: path(ROOTS_DASHBOARD, '/task/new'),
    list: path(ROOTS_DASHBOARD, '/task/list'),
    approvedList: path(ROOTS_DASHBOARD, '/task/approved'),
    viewOnly: path(ROOTS_DASHBOARD, '/task/list-view'),
    reviewedList: path(ROOTS_DASHBOARD, '/task/reviewed-claims'),
    analystClaims: path(ROOTS_DASHBOARD, '/task/analyst-claims'),
    cards: path(ROOTS_DASHBOARD, '/task/cards'),
    profile: path(ROOTS_DASHBOARD, '/task/profile'),
    account: path(ROOTS_DASHBOARD, '/task/account'),
    view: (guid) => path(ROOTS_DASHBOARD, `/task/${guid}`),
    edit: (guid) => path(ROOTS_DASHBOARD, `/task/${guid}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `/task/reece-chung/edit`),
  },
};

export const PATH_DOCS = {
  root: '',
  changelog: '',
};
